module.exports = __webpack_public_path__ + "media/customizations/bridgelandlife/back-6d420f49b3b2640956352172e625b816.jpg";